// extracted by mini-css-extract-plugin
export default {"imgContain":"iH","content":"jH","titleAndImage":"kH","title":"lH","text":"mH","rhodeTitle":"nH","shortHR":"oH","modal_root":"pH","x_mark":"qH","flavorStickModal":"rH","greenBox":"sH"};
    if(module.hot) {
      // 1713969934076
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  